<template>
  <v-icon
    :color="color"
    @click="reverseEnum"
    class="ml-2"
    hide-details
  >
    {{ icon }}
  </v-icon>
</template>
<script>
import { DataType } from '@/util'

export default {
  name: 'arb-review-checkbox',
  props: {
    value: {
      type: Number,
      default: null
    },
    /*
    * @discription: type of checkbox
    * 'primary' | 'error'
    * */
    type: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checkbox: this.value,
      color: 'gray',
      icon: 'far fa-square',
      checkEnum: []
    }
  },
  watch: {
    value () {
      this.checkbox = this.value
      this.initIcon()
    },
    checkbox (val) {
      this.$emit('input', val)
      this.$emit('change', val)
    }
  },
  created () {
    this.initIcon()
  },
  methods: {
    initIcon () {
      if (this.type === 'error') {
        switch (this.value) {
          case DataType.ReviewStatusEnum.VERIFY.value:
            this.checkEnum = [
              { value: DataType.ReviewStatusEnum.VERIFY.value, icon: 'fas fa-check-square', color: 'primary' },
              { value: DataType.ReviewStatusEnum.NOT_VERIFY.value, icon: 'far fa-square', color: 'gray' }
            ]
            break
          case DataType.ReviewStatusEnum.CORRECT.value:
            this.checkEnum = [
              { value: DataType.ReviewStatusEnum.CORRECT.value, icon: 'fas fa-times-square', color: 'red' },
              { value: DataType.ReviewStatusEnum.NOT_VERIFY.value, icon: 'far fa-square', color: 'gray' }
            ]
            break
          case DataType.ReviewStatusEnum.NOT_VERIFY.value:
          default:
            this.checkEnum = [
              { value: DataType.ReviewStatusEnum.NOT_VERIFY.value, icon: 'far fa-square', color: 'gray' },
              { value: DataType.ReviewStatusEnum.CORRECT.value, icon: 'fas fa-times-square', color: 'red' }
            ]
            break
        }
      } else {
        switch (this.value) {
          case DataType.ReviewStatusEnum.VERIFY.value:
            this.checkEnum = [
              { value: DataType.ReviewStatusEnum.VERIFY.value, icon: 'fas fa-check-square', color: 'primary' },
              { value: DataType.ReviewStatusEnum.NOT_VERIFY.value, icon: 'far fa-square', color: 'gray' }
            ]
            break
          case DataType.ReviewStatusEnum.NOT_VERIFY.value:
          default:
            this.checkEnum = [
              { value: DataType.ReviewStatusEnum.NOT_VERIFY.value, icon: 'far fa-square', color: 'gray' },
              { value: DataType.ReviewStatusEnum.VERIFY.value, icon: 'fas fa-check-square', color: 'primary' }
            ]
            break
        }
      }
      this.initValue()
    },
    initValue () {
      this.checkbox = this.checkEnum[0].value
      this.color = this.checkEnum[0].color
      this.icon = this.checkEnum[0].icon
    },
    reverseEnum () {
      this.checkEnum.reverse()
      this.initValue()
    }
  }
}
</script>
